module.exports = __webpack_public_path__ + "static/child-growth-chart-1d465bdacec15dd6414483e588e6040d.png";